import { useState } from 'react';

type Props = {
  timeout?: number;
};

export const useClipboard = ({ timeout = 3000 }: Props = {}) => {
  const [isCopied, setIsCopied] = useState(false);

  const copy = async (value: string) => {
    setIsCopied(false);
    try {
      if (RUNTIME_ENV === 'native') {
        const { Clipboard } = await import('@capacitor/clipboard');
        await Clipboard.write({
          string: value,
        });
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), timeout);

        return true;
      }
      await navigator.clipboard.writeText(value);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), timeout);

      return true;
    } catch (error) {
      console.error('Error copying', error);
      return false;
    }
  };

  return { copy, isCopied };
};
